export default __webpack_public_path__ + "static/organizeFeatureHome-3079ee0c3c750d8303de844d5d7d7dfc.svg";